import './app/publicPath'

const Vue = window.Vue

Vue.component('HdsSingleitemTitle', () => import('./app/components/item/singleitem/HdsSingleitemTitle.vue'))
Vue.component('HdsSingleitemTitleMobile', () => import('./app/components/item/singleitem/HdsSingleitemTitleMobile.vue'))
Vue.component('HdsSingleitemShortdescription', () => import('./app/components/item/singleitem/HdsSingleitemShortdescription.vue'))
Vue.component('HdsSingleitemDescription', () => import('./app/components/item/singleitem/HdsSingleitemDescription.vue'))
Vue.component('HdsSingleitemTechnicaldata', () => import('./app/components/item/singleitem/HdsSingleitemTechnicaldata.vue'))
Vue.component('HdsSingleitemAvailibility', () => import('./app/components/item/singleitem/HdsSingleitemAvailibility.vue'))
Vue.component('HdsSingleitemSingleAvailibility', () => import('./app/components/item/singleitem/HdsSingleitemSingleAvailibility.vue'))
Vue.component('HdsSingleitemDocuments', () => import('./app/components/item/singleitem/HdsSingleitemDocuments.vue'))
Vue.component('HdsSingleitemVariationlist', () => import('./app/components/item/singleitem/HdsSingleitemVariationlist.vue'))
